/**
 * Tutulist is phasing out PayPal. While this is false, buyers can't choose PayPal at checkout and
 * sellers aren't offered PayPal as a payout method (Stripe only). Orders already paid with PayPal
 * still finish normally: the PayPal server routes and transitions are left in place for them.
 */
export const PAYPAL_ENABLED = false;
